import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive, Router } from '@angular/router';
import { AuthService } from '../../core/auth.service';
import { environment } from '../../../environments/environment';

export interface NavItem {
  path: string;
  label: string;
  icon: string;
  perms?: string[];
}

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  public auth = inject(AuthService);
  private router = inject(Router);

  visitorAppUrl = environment.visitorAppUrl;
  mobileMenuOpen = false;

  private allLinks: NavItem[] = [
    { path: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { path: '/visitors', label: 'Visitors (CRM)', icon: 'visitors', perms: ['v_list', 'v_profile'] },
    { path: '/rewards', label: 'Rewards & Vouchers', icon: 'rewards', perms: ['r_list', 'r_create', 'r_redeem'] },
    { path: '/audit', label: 'Audit Log', icon: 'audit', perms: ['a_view'] },
    { path: '/activations', label: 'Stamp Scans', icon: 'activations', perms: ['c_scans', 'c_list', 'c_create'] },
    { path: '/push-notifications', label: 'Push Notifications', icon: 'push', perms: ['cnt_events', 'v_list'] },
    { path: '/content', label: 'Content & CMS', icon: 'content', perms: ['cnt_events', 'cnt_banners', 'cnt_stamps', 'cnt_media'] },
    { path: '/app-info', label: 'App Info & Legal', icon: 'app-info', perms: ['cnt_events'] },
    { path: '/users', label: 'Admin Users', icon: 'users', perms: ['u_list', 'u_roles', 'u_invite'] },
    { path: '/access-rights', label: 'Access Rights & Roles', icon: 'roles', perms: ['u_roles', 'u_list'] },
    { path: '/ota', label: 'OTA Releases', icon: 'ota', perms: ['u_roles', 'cnt_events', 'cnt_media'] },
  ];

  async ngOnInit() {
    await this.auth.refreshUser();
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  get links(): NavItem[] {
    if (this.auth.isSuperAdmin) {
      return this.allLinks;
    }
    return this.allLinks.filter(l => !l.perms || this.auth.hasAnyPermission(l.perms));
  }

  get email(): string {
    return this.auth.email;
  }

  get name(): string {
    return this.auth.user?.name || this.auth.email.split('@')[0];
  }

  get roleBadge(): string {
    return this.auth.roleBadge;
  }

  get roleColor(): string {
    return this.auth.roleColor;
  }

  get initials(): string {
    return (this.name || this.email || 'AD').substring(0, 2).toUpperCase();
  }

  logout() {
    this.closeMobileMenu();
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
